import { defaultQueryOptions } from 'constants/'
import { useQuery } from 'react-query'
import { Item, QueryOptions } from 'types'
import { GetItemsQuery, useItemService } from '../services/useItemService'

const hookName = 'useItems'

interface UseItemsResult {
  data: Item[]
  isError: boolean
  isLoading: boolean
}

const useItems = (query: GetItemsQuery, options: QueryOptions = { enabled: true }): UseItemsResult => {
  const { gids = [] } = query
  const { getItems } = useItemService()
  const queryKey = gids.length > 0 ? [...gids].sort().join(',') : ''

  const queryResult = useQuery([hookName, queryKey], () => getItems(query), {
    ...defaultQueryOptions,
    ...options,
    enabled: options.enabled !== false && gids.length > 0,
  })

  const data = queryResult.data?.data ?? []

  return {
    data,
    isError: queryResult.isError ?? false,
    isLoading: queryResult.isLoading ?? false,
  }
}

export { useItems }
export type { UseItemsResult }
